module.exports = __webpack_public_path__ + "static/media/login.045b3407.svg";